import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LogoMark } from "@/components/Logo";

export default function NotFound() {
  return (
    <div
      data-testid="not-found-page"
      className="jtk-dotgrid relative flex min-h-screen flex-col items-center justify-center bg-navy px-5 text-center"
    >
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[420px] w-[420px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-electric/15 blur-[130px]" />
      <LogoMark size={52} />
      <p className="relative mt-10 font-heading text-7xl font-extrabold tracking-tight text-white sm:text-8xl">
        4<span className="jtk-text-gradient">0</span>4
      </p>
      <p className="relative mt-4 font-mono text-xs font-semibold uppercase tracking-[0.3em] text-cyan-400">
        Signal Lost
      </p>
      <p className="relative mt-4 max-w-md text-sm leading-relaxed text-slate-400">
        The route you are looking for does not exist. Let&apos;s get you back to a live connection.
      </p>
      <Link
        data-testid="not-found-home-link"
        to="/"
        className="group relative mt-9 inline-flex items-center gap-2.5 rounded-full bg-electric px-7 py-3.5 text-sm font-semibold text-white shadow-xl shadow-blue-600/25 transition-all duration-300 hover:-translate-y-0.5 hover:bg-blue-500"
      >
        <ArrowLeft size={16} className="transition-transform duration-300 group-hover:-translate-x-1" />
        Back to Home
      </Link>
    </div>
  );
}
